import React, { useEffect, useState } from 'react'
import LandingPageHeader from './LandingPageHeader'
import { Button, Col, Container, Image, Modal, Row } from 'react-bootstrap'
import axios from 'axios';
import { Link } from 'react-router-dom';
export default function LandingPage1() {
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  //is_download_btn_clicked
  useEffect(() => {
    //storeAppDownloads
    uploadAppDownloadData(0)
  }, []);
  const uploadAppDownloadData = async (btn_pressed) => {
    const data = {
      page_name: 'landingpage1',
      app_version: '1.1',
      is_download_btn_clicked:btn_pressed
    }
    await axios.post(`${process.env.REACT_APP_API_URL}/storeAppDownloads`, data)
      .then((response) => {
        console.log(response);
      })
  }


  return (
    <>
      <Row justify="center">
        <Col span={4}>
          <LandingPageHeader />
          <Container style={{ marginTop: "19%" }} onClick={handleShow}>
            <a onClick={()=>{uploadAppDownloadData(1)}} download={true} href={`${process.env.PUBLIC_URL}/apks/app-releasev1_1.apk`}>
              <Image
                src={`${process.env.PUBLIC_URL}/landing_page_image/landingpage1.png`}
                style={{ width: "100%" }}
              />
            </a>
          </Container>
        </Col>
      </Row>
      <Modal show={show} onHide={handleClose} centered>
        <Modal.Header>
          <div onClick={handleClose} style={{textAlign:'right'}}>X</div>
        </Modal.Header>
       
        <Modal.Body>
          <Image
            src={`${process.env.PUBLIC_URL}/images/download _warning.jpg`}
            style={{ width: "100%" }}
          />
        </Modal.Body>
      </Modal>
    </>
  )
}
